import React from "react";
import { Box, Typography } from "@mui/material";
import AnimatedText from "../../../user/file_management/component/AnimatedText";

export default function RootFolder({ folders, onFolderSelect, departmentId }) {
  if (!folders || folders.length === 0) {
    return <Typography>No category folders found.</Typography>;
  }

  // Split folders: 4 on top, 3 on bottom
  const topRow = folders.slice(0, 4);
  const bottomRow = folders.slice(4, 7);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mt: 5,
      }}
    >
      <AnimatedText text={`${departmentId} Dataset`} />
      {/* Top row */}

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 3,
          mb: 3,
        }}
      >
        {topRow.map((folder) => (
          <FolderCard
            key={folder.folderId}
            folder={folder}
            onClick={() => onFolderSelect(folder)}
          />
        ))}
      </Box>
      {/* Bottom row, centered under top row */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 3,
        }}
      >
        {bottomRow.map((folder) => (
          <FolderCard
            key={folder.folderId}
            folder={folder}
            onClick={() => onFolderSelect(folder)}
          />
        ))}
      </Box>
    </Box>
  );
}

// FolderCard component for reusability and clarity
function FolderCard({ folder, onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        cursor: "pointer",
        p: 3,
        borderRadius: 3,
        backgroundColor: "#18191C",
        boxShadow: "0 2px 8px 0 rgba(0,0,0,0.07)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minWidth: 220,
        minHeight: 140,
        transition: "background-color 0.2s, box-shadow 0.2s",
        "&:hover": {
          backgroundColor: "#23263b",
          boxShadow: "0 4px 16px 0 rgba(35,38,59,0.14)",
        },
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ marginBottom: 14, color: "#fff" }}
      >
        <path d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-6l-2-2H5a2 2 0 0 0-2 2z" />
      </svg>
      <Typography
        variant="body1"
        sx={{
          color: "#fff",
          fontWeight: 500,
          textAlign: "center",
          wordBreak: "break-word",
          fontSize: 18,
        }}
      >
        {folder.folderName || folder.folderId}
      </Typography>
    </Box>
  );
}
